{
  "title": "Credentials",
  "subtitle": "Auth-Tokens für HTTP-Requests — werden automatisch eingehängt, wenn die URL zum Host im Muster passt.",
  "loading": "Lade…",
  "extension_empty": "Noch keine Extension-Zugangsdaten vorhanden.",
  "security_note": "Tokens kommen NIE im LLM-Kontext oder Tool-Result vor. Sie werden nur server-seitig in Header injected wenn ein fetch_url gegen die passende URL läuft.",
  "new": "Neuer Credential",
  "new_title": "Neuer Credential",
  "edit_title": "Credential bearbeiten: {{name}}",
  "delete_confirm": "Credential \"{{name}}\" wirklich löschen?",
  "empty": "Noch keine Credentials.",
  "name": "Name",
  "name_invalid": "Ungültig — nur a-z, 0-9, _ und -, max 50 Zeichen.",
  "type": "Typ",
  "type_bearer": "Bearer Token",
  "type_basic": "Basic Auth (user:pass)",
  "type_cookie": "Cookie",
  "type_header": "Custom Header",
  "type_query": "Query Parameter",
  "type_ssh_key": "SSH-Key",
  "value": "Wert",
  "value_hint_bearer": "Z.B. ein API-Token. Wird als 'Authorization: Bearer <wert>' gesendet.",
  "value_hint_basic": "Format 'user:passwort'. Wird base64-kodiert als 'Authorization: Basic ...' gesendet.",
  "value_hint_cookie": "Z.B. 'session=abc123'. Wird als 'Cookie: <wert>' gesendet.",
  "value_hint_header": "Wert des Custom-Headers.",
  "value_hint_query": "Wert des Query-Params.",
  "header_name": "Header-Name",
  "header_name_required": "Header-Name ist Pflicht.",
  "query_param": "Query-Param-Name",
  "query_param_required": "Query-Param-Name ist Pflicht.",
  "url_pattern": "URL-Pattern",
  "url_pattern_hint": "Muster mit konkretem Host, z.B. 'https://api.example.com/*' oder 'https://*.example.com/*'. Nur dann wird der Zugang eingehängt. '*' (alle URLs) setzt fetch_url nie ein.",
  "description": "Beschreibung",
  "ssh_private_key": "Private Key (PEM)",
  "ssh_private_key_hint": "OpenSSH- oder PEM-Format. Wird verschlüsselt gespeichert und nie an den Agenten weitergegeben.",
  "ssh_host": "Hostname / IP",
  "ssh_host_hint": "Host auf den der Agent per SSH zugreifen soll.",
  "ssh_host_required": "Hostname / IP ist Pflicht.",
  "ssh_host_invalid": "Nur Buchstaben, Ziffern, Punkte und Bindestriche erlaubt (max. 253 Zeichen).",
  "ssh_user": "SSH-Username",
  "ssh_user_required": "SSH-Username ist Pflicht.",
  "ssh_user_invalid": "Nur Buchstaben, Ziffern, Punkte, Unterstriche und Bindestriche erlaubt (max. 32 Zeichen).",
  "url_pattern_wildcard_warning": "Dieses Muster nennt keinen konkreten Host. fetch_url setzt den Zugang deshalb nie ein — auch nicht, wenn ein Agent ihn per Namen anfordert. Trag den Host ein, für den er gedacht ist.",
  "not_host_bound": "Kein Host — fetch_url setzt ihn nicht ein",
  "unbound_banner_one": "{{count}} Zugang ohne konkreten Host wird von fetch_url nie eingesetzt. Öffne ihn und trag den Host ein, für den er gedacht ist.",
  "unbound_banner_other": "{{count}} Zugänge ohne konkreten Host werden von fetch_url nie eingesetzt. Öffne sie und trag jeweils den Host ein, für den sie gedacht sind."
}
